export const OFFICE_TOKEN_INVALID = "E_OFFICE_TOKEN_INVALID";
export const OFFICE_USER_UNKNOWN = "E_OFFICE_USER_UNKNOWN";
export const OFFICE_USER_INACTIVE = "E_OFFICE_USER_INACTIVE";
export class OfficeSessionError extends Error {
    constructor(status, code, message){
        super(message);
        this.name = "OfficeSessionError";
        this.status = status;
        this.code = code;
    }
    status;
    code;
}
async function errorOf(response) {
    const body = await response.json().catch(()=>null);
    return new OfficeSessionError(response.status, typeof body?.code === "string" ? body.code : null, typeof body?.message === "string" ? body.message : `HTTP ${response.status}`);
}
export async function createOfficeSession(gatewayUrl, auth0AccessToken) {
    const response = await fetch(`${gatewayUrl}/auth/office/session`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${auth0AccessToken}`
        }
    });
    if (!response.ok) {
        throw await errorOf(response);
    }
    return await response.json();
}
export async function revokeGatewaySession(gatewayUrl, gatewayToken) {
    await fetch(`${gatewayUrl}/auth/logout`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${gatewayToken}`
        }
    });
}
export function sessionUser(session) {
    return {
        email: session.user.email,
        name: session.user.fullName,
        meta: {
            access_token: {
                type: "bearer",
                token: session.access_token,
                refreshToken: null
            },
            dbUser: session.user,
            organization: session.organization
        }
    };
}
